import { useQuery } from "@tanstack/react-query";
import NotificationItem from "./NotificationItem";
import { axiosInstance } from "hooks/api/config";

export interface Notification {
  id: number;
  title: string;
  body: string;
  created_at: string;
  updated_at: string;
}

export const notifications: Notification[] = [
  {
    id: 10,
    title: "System Maintenance",
    body: "System will be under maintenance on January 12, 2024 from 2:00 AM to 4:00 AM GMT.",
    created_at: "2024-12-09T08:00:00Z",
    updated_at: "2024-01-09T08:00:00Z",
  },
  {
    id: 8,
    title: "Payment Confirmation",
    body: "Tender fee payment for TND2024-008 has been received and confirmed.",
    created_at: "2025-01-09T10:15:00Z",
    updated_at: "2024-01-09T10:15:00Z",
  },
  {
    id: 9,
    title: "Deadline Extension",
    body: "The submission deadline for tender TND2024-009 has been extended to January 20, 2024.",
    created_at: "2024-12-09T09:30:00Z",
    updated_at: "2024-01-09T09:30:00Z",
  },
  {
    id: 10,
    title: "System Maintenance",
    body: "System will be under maintenance on January 12, 2024 from 2:00 AM to 4:00 AM GMT.",
    created_at: "2024-01-01T08:00:00Z",
    updated_at: "2024-01-09T08:00:00Z",
  },
];

export default function NotificationList({
  limit = null
}: {
  limit?: number | null;
}) {

  const notifications = useQuery({
    queryKey: ["notifications"],
    queryFn: async () => {
      return await axiosInstance.get(`suppliers/1/notifications?limit=${limit}`);
    },
  });

  return (
    <div className="divide-y divide-gray-200">
      {
        notifications.data?.data?.length === 0 && (
          <div className="p-4 text-center text-gray-500">No notifications</div>
        )
      }
      {notifications?.data?.data?.map((notification: {
        id: number;
        title: string;
        body: string;
        created_at: string;
        updated_at: string;
      }) => (
        <NotificationItem key={notification.id} notification={notification} />
      ))}
    </div>
  );
}
